import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admin: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    getAdminSuccess: (state, action) => {
      state.adminList = action.payload;
    },
    getUserSuccess: (state, action) => {
      state.userList = action.payload;
    },
    getNotificationsSuccess: (state, action) => {
      state.notifications = action.payload;
    },
    getApprovedAstrologersSuccess: (state, action) => {
      state.approve_astrologers = action.payload;
    }
  },
  selectors: {
    getAllAdminList: (state) => state.adminList ?? [],
    getUserList: (state) => state.userList ?? [],
    getAllNotifications: (state) => state.notifications ?? [],
    getApprovedAstrologers: (state) =>  state.approve_astrologers ?? [],
  }
});

export const {
  getAdminSuccess, getUserSuccess, getNotificationsSuccess, getApprovedAstrologersSuccess
} = adminSlice.actions;

export const { getAllAdminList, getUserList, getAllNotifications, getApprovedAstrologers } =
adminSlice.selectors;

export default adminSlice.reducer;
